import axios from "axios";
import Swal from "sweetalert2";
import { baseUrl, errorTranslate } from "./util";

export const createHighlight = ({ key, value, target_user }) => {
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");
  var data = JSON.stringify({
    key: key,
    value: value,
    year: year,
    target_user: target_user ? target_user : null,
  });

  var config = {
    method: "post",
    url: baseUrl + "/api/business/report/highlight",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {})
    .catch(function (error) {
      // console.log(error)
      if (error.response.data.message === "key exist") {
        updateHighlight({ key: key, value: value });
      }
    });
};

export const updateHighlight = ({ key, value, swal = false, target_user }) => {
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");
  var data = JSON.stringify({
    key: key,
    value: value === "" ? "emptyvalue" : value,
    year: year,
    target_user: target_user ? target_user : null,
  });

  var config = {
    method: "put",
    url: baseUrl + "/api/business/report/highlight/" + key,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      if (swal) {
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      }
    })
    .catch(function (error) {
      if (swal) {
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      }
      // setSaving(false)
    });
};

export const getHighlight = ({ key, setValue, activeCompany, setUser }) => {
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");
  const token = localStorage.getItem("access_token");

  axios
    .get(`${baseUrl}/api/business/report/highlight/${key}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      params: { year: year },
    })
    .then((response) => {
      const data = response.data;

      if (
        activeCompany !== "main" &&
        data.shared &&
        data.shared[activeCompany]
      ) {
        // Use shared data if company is shared
        setValue(data.shared[activeCompany][0]?.value || "");
        setUser(data.read_or_write[activeCompany][0]?.user || null);
      } else {
        // Use normal data
        setValue(data.data.value === "emptyvalue" ? "" : data.data.value);
      }
    })
    .catch((error) => {
      if (error.response?.status === 404) {
        createHighlight({ key: key, value: "emptyvalue" });
      }
    });
};

export const getHighlightsCompanyReport = ({ setValue }) => {
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");
  const highlights = [
    "highlight0",
    "highlight1",
    "highlight2",
    "highlight3",
    "highlight4",
    "highlight5",
    "highlight6",
    "highlight7",
    "highlight8",
  ];
  var config = {
    method: "get",
    url: baseUrl + "/api/business/report/highlight",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    params: {
      year: year,
    },
  };

  axios(config)
    .then(function (response) {
      if (response.data.data.value === "emptyvalue") setValue("");
      else setValue(response.data.data.value);
    })
    .catch(function (error) {
      if (error.response.status === 404) {
        // createHighlight({key:key,value:"emptyvalue"})
      }
    });
};
